<div echarts [options]="chartOption" class="chart"></div>
